<mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:90%;min-height: 600px;">
    <mat-card-header>
        @if(isProcessing){
            <div style="margin-bottom:30px;width:100%;">
                <app-processing-banner [WaitMessage]="processingMessage" style="width:100%"></app-processing-banner>
            </div>
        }
    </mat-card-header>

    <mat-card-content>
        <span style="margin-left: 0px;margin-top:20px;"  class="ace-heading-text-level-2">Flash Parking Utilities</span>

        <mat-tab-group>
            <mat-tab label="Reset All Locations">

            </mat-tab>
            <mat-tab label="TBD">

            </mat-tab>
        </mat-tab-group>

    </mat-card-content>
</mat-card>

